import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import { Box, TextInputProps } from '@mantine/core';
import ReactDatePicker, { DatePickerProps as ReactDatePickerProps } from 'react-datepicker';

import { DatePickerHeader, DatePickerInput } from './DatePickerSubcomponents';

import 'react-datepicker/dist/react-datepicker.css';
import './datePickerStylings.scss';

export interface DatePickerProps {
  inputProps?: Partial<TextInputProps>;
  onlyOpenCalenderOnIconClick?: boolean;
  datePickerProps?: ReactDatePickerProps & {
    selectsRange?: never;
    selectsMultiple?: never;
  };
  styles?: Record<string, string>;
}

const DatePicker = ({
  inputProps = {},
  onlyOpenCalenderOnIconClick = false,
  datePickerProps,
  styles
}: DatePickerProps): React.ReactElement => {
  const { onChange, isClearable, ...restDatePickerProps } = datePickerProps ?? {};
  const { name } = inputProps;
  const [calenderOpen, setCalenderOpen] = useState<boolean>(false);

  return (
    <Box>
      <ReactDatePicker
        name={name}
        open={calenderOpen}
        popperContainer={({ children }: any) => createPortal(children, document.body)}
        customInput={
          <DatePickerInput
            {...inputProps}
            styles={styles}
            setCalenderOpen={setCalenderOpen}
            onClear={(e) => onChange && onChange(null, e)}
            isClearable={isClearable}
            selected={datePickerProps?.selected}
          />
        }
        onInputClick={() => {
          if (!onlyOpenCalenderOnIconClick) {
            setCalenderOpen(true);
          }
        }}
        disabled={inputProps.disabled}
        placeholderText={inputProps.placeholder}
        onClickOutside={() => setCalenderOpen(false)}
        onChange={(date, e) => {
          setCalenderOpen(false);
          if (onChange !== undefined) {
            onChange(date, e);
          }
        }}
        renderCustomHeader={DatePickerHeader}
        showPopperArrow={false}
        {...restDatePickerProps}
      />
    </Box>
  );
};

export default DatePicker;
